import { combineReducers } from '@reduxjs/toolkit';
import AuthReducer from './reducer';
const reducer = combineReducers({
  AuthReducer
});

export default reducer;
